import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)



const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes : [
    {
      path: '/login',
      name: 'login',
      meta: {layout: 'auth'},
      component: () => import('@/views/auth/Login.vue')
    },
    {
      path: '/register',
      name: 'register',
      meta: {layout: 'auth'},
      component: () => import('@/views/auth/Register.vue')
    },

    {
      path: '/',
      name: 'dashboard',
      meta: {layout: 'main'},
      component: () => import('@/views/main/Dashboard.vue')
    },
    {
      path: '/markets',
      name: 'markets',
      meta: {layout: 'main'},
      component: () => import('@/views/main/Markets.vue')
    },
    // {
    //   path: '/ticker',
    //   name: 'ticker',
    //   meta: {layout: 'main'},
    //   component: () => import('@/views/main/SymbolTicker.vue')
    // },
    {
      path: '/wallets',
      name: 'wallets',
      meta: {layout: 'main'},
      component: () => import('@/views/main/Wallets.vue')
    },


  ]
})

export default router
